<template>
  <div class="water-data-table-overview">
    <div class="overview-table-row">
      <div class="overview-table">
        <MeasurementObjectsSelectTable
          :projectId="$route.params.projectId"
          :updateSelectedRows="() => {}"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          @update:selected="onUpdateMeasurementObject"
        />
      </div>
      <div class="overview-table">
        <GaugingTubesTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :updateSelectedRows="onUpdateGaugingTube"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
        />
      </div>
      <div class="overview-table">
        <FinishingsTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
        />
      </div>
    </div>
    <div class="overview-table-row">
      <div class="overview-table">
        <WaterSamplesTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :selectedGaugingTube="gaugingTube"
          :updateSelectedRows="onUpdateWaterSample"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
          sampleType="Ground"
        />
      </div>
      <div class="overview-table">
        <BottlesTable
          :projectId="$route.params.projectId"
          :projectCode="projectCode"
          :selectedMeasurementObject="measurementObject"
          :selectedGaugingTube="gaugingTube"
          :selectedWaterSample="waterSample"
          :enableCreateTableRowAction="enableCreateTableRowAction"
          :enableDeleteTableRowAction="enableDeleteTableRowAction"
          :enableUpdateTableRowAction="enableUpdateTableRowAction"
          :enableColumnChooser="enableColumnChooser"
          :searchPanelEnabled="searchPanelEnabled"
          :enableExportSettings="enableExportSettings"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { MeasurementObjectsSelectTable, GaugingTubesTable, FinishingsTable, WaterSamplesTable, BottlesTable } from '@/components/dynamicTables/tables'
import Popup from '@/utils/popup'
import Config from '@/configurations/config'
import stringUtils from '@/utils/stringUtils'

const TiPopup = Popup[Config.platform].default

export default {
  name: 'GroundWaterDataTableOverview',
  components: {
    MeasurementObjectsSelectTable,
    GaugingTubesTable,
    FinishingsTable,
    WaterSamplesTable,
    BottlesTable
  },
  props: {
    enableCreateTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableDeleteTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableUpdateTableRowAction: {
      required: false,
      default() {
        return true
      }
    },
    enableColumnChooser: {
      required: false,
      default() {
        return true
      }
    },
    searchPanelEnabled: {
      required: false,
      default() {
        return true
      }
    },
    enableExportSettings: {
      required: false,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      measurementObject: {},
      gaugingTube: {},
      waterSample: {},
      projectCode: ''
    }
  },
  async created() {
    await this.setCurrentProject()
  },
  methods: {
    async onUpdateMeasurementObject(data) {
      this.measurementObject = data
    },
    async onUpdateGaugingTube(data) {
      if (data && Array.isArray(data) && data.length === 1) {
        this.gaugingTube = data[0]
      } else {
        this.gaugingTube = {}
      }
    },
    async onUpdateWaterSample(data) {
      if (data && Array.isArray(data) && data.length === 1) {
        this.waterSample = data[0]
      } else {
        this.waterSample = {}
      }
    },
    async setCurrentProject() {
      if (stringUtils.isNullOrEmptyOrWhitespace(this.$route.params.projectId)) {
        TiPopup.popup(this.$t('message.projectNotFound'))
        return
      }

      await this.$store.dispatch('fetchProject', {
        PrID: this.$route.params.projectId
      })
      const project = this.$store.state.currentProject

      if (project && project.PrID) {
        this.projectCode = project.PrCode
      } else {
        TiPopup.popup(this.$t('message.projectNotFound'))
      }
    },
    async handleErrorResponse(error, errorMessage = 'message.UnknownError') {
      console.log(error)
      TiPopup.popup(this.$t(errorMessage))
    }
  }
}
</script>

<style>
.water-data-table-overview h2 {
  margin-top: 5px;
  font-size: 20px;
}
.water-data-table-overview {
  height: 100%;
}
.water-data-table-overview .overview-table-row {
  height: 50%;
}
.water-data-table-overview .overview-table-row {
  display: flex;
}
.water-data-table-overview .overview-table-row:first-child .overview-table:first-child {
  flex: 2;
}
.water-data-table-overview .overview-table-row:first-child .overview-table:nth-child(2) {
  flex: 4;
}
.water-data-table-overview .overview-table-row:first-child .overview-table:nth-child(3) {
  flex: 3;
}
.water-data-table-overview .overview-table-row:nth-child(2) .overview-table:first-child {
  flex: 6;
}
.water-data-table-overview .overview-table-row:nth-child(2) .overview-table:nth-child(2) {
  flex: 3;
}
.water-data-table-overview .overview-table-row .overview-table > div {
  margin-left: 10px;
}
.water-data-table-overview .overview-table-row:nth-child(2) {
  padding-top: 10px;
}
.water-data-table-overview .overview-table {
  overflow: hidden;
}
.water-data-table-overview .overview-table > div,
.water-data-table-overview .overview-table > div > div {
  height: 100%;
}
.water-data-table-overview .overview-table-row .overview-table > div,
.water-data-table-overview .overview-table-row .overview-table > div > div {
  height: 100%;
}
.dx-datagrid-search-panel {
  margin-left: 0px;
}
</style>
